import "./Footer.scss";
// import facebook from "../../assets/facebook.png";
// import twitter from "../../assets/twitter.png";
// import linkedin from "../../assets/linkedin.png";
// import instagram from "../../assets/instagram.png";
import facebook from '../../assets/icon2.svg';
import twitter from '../../assets/icon1.png';
import linkedin from '../../assets/icon3.svg';
import instagram from '../../assets/icon4.svg';

export default function Footerlast() {
  return (
    <div className="footer">
      {/* <div className="top  spacing">
        <div className="content">
          <h1>Ready to grow with crypto?</h1>
          <div className="para">
            <p>Start accepting crypto payments today</p>
            <p>— it's fast, secure, and built for your business.</p>
          </div>
          <div className="btn">
            <button>Contact Us</button>
            <button className="createaccount">Create account</button>
          </div>
        </div>
      </div> */}
      <div className="bottom">
        <span>Copyrights © 2025. All rights reserved</span>
        <div className="logos">
          <div className="image"><a href="https://web.facebook.com/Floxypay" rel="noopener noreferrer" target="_blank"><img src={facebook} alt="error" /></a></div>
          <div className="image"><a href="https://twitter.com/floxy_pay" rel="noopener noreferrer" target="_blank"><img src={twitter} alt="error" /></a></div> 
          <div className="image"> <a href="https://www.linkedin.com/company/floxypay/" rel="noopener noreferrer" target="_blank"><img src={linkedin} alt="error" /></a></div> 
          <div className="image"> <a href="https://www.instagram.com/floxypayofficial/" rel="noopener noreferrer" target="_blank"><img src={instagram} alt="error" /></a></div> 
        </div>
      </div>
    </div>
  );
}
